import React from 'react'
import { IonHeader, IonToolbar, IonButton, IonIcon, IonTitle, IonButtons, IonBackButton } from '@ionic/react'
import { arrowBack } from 'ionicons/icons';
import './ModalHeader.scss'

type HeaderProps = {
	pageTitle: string,
  closeModal?: () => void
  button?: any
  buttonFunction?: () => void
  buttonColor?: string
  buttonTitle?: string
  viewMode?: string
  link?: string
}

const ModalHeader = ({ link, pageTitle, closeModal, buttonTitle, viewMode, button, buttonFunction }: HeaderProps ) => {
  return (
    <IonHeader class="modalHeader" slot="fixed">
      <IonToolbar>
        { link ? 
        <IonButtons slot="start" className="mr-2">
          {/* <IonButton 
            routerLink={link}
            routerDirection="back"
            className="modalButton"  
            fill="clear">
            <IonIcon icon={arrowBack} color="dark" size="large"/>
          </IonButton> */}
          <IonBackButton/>
        </IonButtons>
        : 
        <IonButton 
          onClick={closeModal} 
          className="modalButton"  
          slot="start" 
          fill="clear">
          <IonIcon 
            icon={arrowBack} 
            color="dark"
            size="large"/>
        </IonButton>
        }
        <IonTitle class="text_center">{pageTitle}</IonTitle>
        { button ? 
        <IonButtons slot="end">
          <IonButton 
            onClick={buttonFunction} 
            className="modalButton modalButton--end"  
            color={`${viewMode === "teams" ? 'darkblue' : 'primary'}`}
            fill="solid">
            {buttonTitle}
          </IonButton>
        </IonButtons>
        : null}
        
      </IonToolbar>
    </IonHeader>
  )
}

export default ModalHeader
